export default __webpack_public_path__ + "static/media/due-tasks-icon.5b2802ca.svg";